
import Button from '../../../components/base/Button';

export default function ConsultationHeroSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      {/* 背景图片 */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/8800eab9d7bb5f46c547177bb92fc9c4.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* 内容容器 */}
      <div className="relative z-10 w-full h-full flex items-center justify-center px-4 sm:px-6 lg:px-[15%]">
        <div className="w-full max-w-6xl text-center text-white space-y-6 lg:space-y-8">
          {/* 主标题 */}
          <div className="space-y-3 lg:space-y-4">
            <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#cc9966]">
              尊享服务
            </h1>
            <p className="text-sm sm:text-lg lg:text-xl xl:text-2xl font-light">
              专业茶叶顾问·一对一贴心服务
            </p>
          </div>

          {/* 服务特色展示 */}
          <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-6 sm:p-8 lg:p-10 border border-[#cc9966]/30 mx-auto max-w-5xl">
            <h2 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-[#cc9966] mb-6 lg:mb-8">
              为您提供全方位茶叶咨询服务
            </h2>
            
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
              {/* 产品咨询 */}
              <div className="flex flex-col items-center space-y-2 lg:space-y-3 p-3 lg:p-4 bg-white/5 rounded-lg sm:rounded-xl border border-[#cc9966]/20">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className="ri-product-hunt-fill text-lg sm:text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966] text-center">产品咨询</h3>
                <p className="text-xs sm:text-sm text-center text-gray-200 leading-tight">
                  选茶指导
                </p>
              </div>

              {/* 品鉴指导 */}
              <div className="flex flex-col items-center space-y-2 lg:space-y-3 p-3 lg:p-4 bg-white/5 rounded-lg sm:rounded-xl border border-[#cc9966]/20">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className="ri-cup-fill text-lg sm:text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966] text-center">品鉴指导</h3>
                <p className="text-xs sm:text-sm text-center text-gray-200 leading-tight">
                  专业品茶
                </p>
              </div>

              {/* 收藏建议 */}
              <div className="flex flex-col items-center space-y-2 lg:space-y-3 p-3 lg:p-4 bg-white/5 rounded-lg sm:rounded-xl border border-[#cc9966]/20">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className="ri-treasure-map-fill text-lg sm:text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966] text-center">收藏建议</h3>
                <p className="text-xs sm:text-sm text-center text-gray-200 leading-tight">
                  投资指导
                </p>
              </div>

              {/* 定制服务 */}
              <div className="flex flex-col items-center space-y-2 lg:space-y-3 p-3 lg:p-4 bg-white/5 rounded-lg sm:rounded-xl border border-[#cc9966]/20">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className="ri-settings-3-fill text-lg sm:text-xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-xs sm:text-sm lg:text-base font-semibold text-[#cc9966] text-center">定制服务</h3>
                <p className="text-xs sm:text-sm text-center text-gray-200 leading-tight">
                  个性方案
                </p>
              </div>
            </div>
          </div>

          {/* CTA按钮 */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-md mx-auto">
            <Button 
              onClick={scrollToContact}
              variant="primary" 
              size="md"
              className="w-full sm:w-auto bg-[#cc9966] hover:bg-[#b8885a] text-white font-semibold whitespace-nowrap text-xs sm:text-sm"
            >
              立即咨询
            </Button>
            <Button 
              onClick={scrollToContact}
              variant="outline" 
              size="md"
              className="w-full sm:w-auto border-[#cc9966] text-[#cc9966] hover:bg-[#cc9966] hover:text-white font-semibold whitespace-nowrap text-xs sm:text-sm"
            >
              预约专家
            </Button>
          </div>

          {/* 滚动提示 */}
          <div className="absolute bottom-6 lg:bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-down-line text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}